import {
    Row,
    Col
  } from "react-bootstrap";

 const  GetRow=(label,value,headline,extraLongRow)=>{
    if(headline==true)return <Row><Col  className="text-start fw-bold">{label}</Col></Row>;
    
    if(value==null||value==='')return;
    if(value===false)return;
    if(value===true)value="Ja";
    if(value===false)value="Nej";
    if(extraLongRow===true)return <Row><Col  className="text-start">{label}</Col></Row>;
    return <Row><Col xs={4} className="text-start">{label}</Col>  <Col xs={8} className="text-start">{value} </Col></Row>;
  }
  export default GetRow;